import React, { useCallback, useEffect, useState } from 'react';
import { NextPage } from 'next/types';

import { SentimentVeryDissatisfiedOutlinedIcon } from '../assets';
import {
  CardCenteredMessage,
  CardList,
  CardListItem,
} from '../components/cards/card-error/CardError.style';
import CardError from '../components/cards/card-error/CardError';
import { ImageWrapper } from '../styles/shared';
import { getAllTranslations } from '../utils/localize';
import { internationalizationToLanguages } from 'corporate-utils';
import { defaultInternationalization, defaultLanguage } from 'corporate-types';
import { useRouter } from 'next/router';
import { NextSeo } from 'next-seo';
import { DEFAULT_IMAGE } from '../models/domain/const';
import ImageWithFallback from '../components/image-with-fallback/ImageWithFallback';
import { getCompany } from '../utils/company';
import { getLogo } from '../utils/media';
import { Companies } from '../models/domain/enum';

const Custom500: NextPage = () => {
  const [translations, seTranslation] = useState<any>();
  const { title, message, actionText, listItems } =
    translations?.pages?.errors?.internal ?? {};

  const { locale } = useRouter();
  const company = getCompany();
  const createTranslations = useCallback(async () => {
    const allTranslations = await getAllTranslations();
    const translations =
      allTranslations[
        internationalizationToLanguages(
          locale && locale !== 'default' ? locale : defaultInternationalization,
          '500'
        ) || defaultLanguage
      ];

    seTranslation(translations);
  }, [locale]);

  useEffect(() => {
    createTranslations();
  }, [createTranslations]);

  return (
    <>
      <NextSeo title={process?.env?.NEXT_PUBLIC_COMPANY_NAME}></NextSeo>
      <ImageWrapper>
        <ImageWithFallback
          src={getLogo(company)}
          width={
            company === Companies.SIRMAN
              ? '197px'
              : company === Companies.FELSINEA
                ? '233px'
                : '197px'
          }
          height="74px"
          alt="error_logo"
          fallbackSrc={DEFAULT_IMAGE}
          isPrerenderRequest={false}
        />
      </ImageWrapper>
      <CardError
        icon={SentimentVeryDissatisfiedOutlinedIcon}
        title={title ?? 'Ops… something went wrong'}
        actionText={actionText ?? 'Go to home'}
      >
        <>
          <CardCenteredMessage>
            {message ?? 'Internal error page'}
          </CardCenteredMessage>

          <CardList>
            {React.Children.toArray(
              listItems?.map((text: any) => <CardListItem>{text}</CardListItem>)
            )}
          </CardList>
        </>
      </CardError>
    </>
  );
};

export default Custom500;
